import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  EventHero,
  SignatureSection,
  PremiumEventsSection,
  ProcessSection,
  PremiumAboutSection,
  EventContactSection,
} from "../components/EventLandingSections";

export default function Events() {
  return (
    <>
      <Helmet>
        <title>Foodtruck für Events in NRW | Prince of Philly</title>
        <meta
          name="description"
          content="Prince of Philly als Premium Foodtruck für Firmenfeiern, Hochzeiten, private Feiern und Festivals im Ruhrgebiet und in NRW anfragen."
        />
        <link rel="canonical" href="https://princeofphilly.de/events" />
      </Helmet>
      <Header />
      <EventHero />
      <SignatureSection />
      <PremiumEventsSection />
      <ProcessSection />
      <PremiumAboutSection />
      <EventContactSection />
      <Footer />
    </>
  );
}
